<app-mobile-filter-magic-cont
  [hasFilterSelected]="hasActiveFilter"
  [title]="getItemLabel(filter.type, true)"
  [titleProps]="getItemLabelProps(filter.type)"
  [styleByContext]="filterMagicContStyle"
  [individualFilter]="true"
  (clear)="clearIndividualFilter()">
  <ng-container body="body">
    <ng-container *ngIf="isSorter(filter)">
      <app-air-sorter-filter
        [individualFilter]="true"
        [sorterSelected]="orderCriteria$ | async"
        [orderCriteriaSectorNumber]="orderCriteriaSectorNumber$ | async"
        [orderDesc]="orderDesc$ | async"
        [departureCriteria]="getCriteria(filter.type, departureType)"
        [returnCriteria]="getCriteria(filter.type, returnType)"
        [options]="filter"
        [isMobile]="isMobile"
        (sortFlights)="applySorterFilterVm($event)">
      </app-air-sorter-filter>
    </ng-container>

    <ng-container *ngIf="isCheckboxFilter(filter)">
      <app-checkbox-filter
        [individualFilter]="true"
        [options]="filter.value"
        [pickedCheckboxes]="pickedCheckboxes"
        [type]="filter.type"
        [isMobile]="isMobile"
        [label]="getItemLabel(filter.type)"
        [isOpenBox]="true"
        (filter)="checkboxFilterAction($event)">
      </app-checkbox-filter>
    </ng-container>
    <ng-container *ngIf="isSectionCheckBoxFilter(filter)">
      <div class="sector-departure">
        <app-sector-checkbox-filter
          [individualFilter]="true"
          [isBuses]="false"
          [tripType]="1"
          [pickedCheckboxes]="pickedAirportsCheckboxes"
          [options]="filter.value"
          [type]="filter.type"
          [label]="getItemLabel(filter.type)"
          [departureCriteria]="getCriteria(filter.type, departureType)"
          [returnCriteria]="getCriteria(filter.type, returnType)"
          [isMobile]="isMobile"
          [isOpenBox]="true"
          (filter)="searchFlightsWithFilter($event)">
        </app-sector-checkbox-filter>
      </div>
      <div class="sector-return">
        <app-sector-checkbox-filter
          [individualFilter]="true"
          [isBuses]="false"
          [tripType]="2"
          [pickedCheckboxes]="pickedAirportsCheckboxes"
          [options]="filter.value"
          [type]="filter.type"
          [label]="getItemLabel(filter.type)"
          [departureCriteria]="getCriteria(filter.type, departureType)"
          [returnCriteria]="getCriteria(filter.type, returnType)"
          [isMobile]="isMobile"
          [isOpenBox]="true"
          (filter)="searchFlightsWithFilter($event)">
        </app-sector-checkbox-filter>
      </div>
    </ng-container>
    <ng-container *ngIf="isRangeFilter(filter)">
      <ng-container *ngIf="valuesIsArray(filter); else simpleRange">
        <ng-container *ngFor="let range of filter.value; let i = index">
          <app-range-box-filter
            [isOpenBox]="true"
            [index]="i"
            [type]="filter.type"
            [pickedRanges]="pickedRanges$ | async"
            [widgets]="rangeFilter$(filter.type, range.SectorNumber) | async"
            [sector]="range.SectorNumber"
            [individualFilter]="true"
            [label]="getItemLabel(filter.type) | transloco: { filterCriteria: getCriteria(filter.type, range?.SectorNumber, destinationPlace$ | async) }"
            (values)="applyRangeFilter(filter.type, range, $event)">
          </app-range-box-filter>
        </ng-container>
      </ng-container>
      <ng-template #simpleRange>
        <div *ngIf="(filter.value | assignObjectFilterValue) as value">
          <app-range-box-filter
            [individualFilter]="true"
            [isOpenBox]="true"
            [type]="filter.type"
            [pickedRanges]="pickedRanges$ | async"
            [widgets]="rangeFilter$(filter.type) | async"
            [label]="getItemLabel(filter.type) | transloco"
            (values)="applyRangeFilter(filter.type, value, $event)">
          </app-range-box-filter>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</app-mobile-filter-magic-cont>